import type { CSSProperties } from 'react';
import { StatusPill, type StatusTone } from './StatusPill';
import type { CardLifecycleStatus } from '@/types/card';
import { CardStatusMeta } from '@/types/card';

/**
 * VirtualCard
 * --------------------------------
 * 模拟物理 VCC 外观的展示组件。统一渐变 / 字体 / 阴影 / 状态徽章。
 */
export interface VirtualCardProps {
  alias: string;
  brand: string;
  cardholderName: string;
  maskedPan: string;
  expireMonth: number;
  expireYear: number;
  status: CardLifecycleStatus;
  onClick?: () => void;
  style?: CSSProperties;
}

export function VirtualCard({
  alias,
  brand,
  cardholderName,
  maskedPan,
  expireMonth,
  expireYear,
  status,
  onClick,
  style,
}: VirtualCardProps) {
  const meta = CardStatusMeta[status];
  const cardClass = [
    'up-virtual-card',
    meta.frozen ? 'up-virtual-card--frozen' : '',
    meta.closed ? 'up-virtual-card--closed' : '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={cardClass} style={style} onClick={onClick}>
      <div className="up-virtual-card__brand">
        <span>{brand || '—'}</span>
        <StatusPill tone={meta.tone as StatusTone}>{meta.label}</StatusPill>
      </div>
      <div className="up-virtual-card__alias">{alias || '未命名卡片'}</div>
      <div className="up-virtual-card__pan">{maskedPan}</div>
      <div className="up-virtual-card__footer">
        <span>{cardholderName || '—'}</span>
        <span>
          {String(expireMonth).padStart(2, '0')}/{String(expireYear).slice(-2)}
        </span>
      </div>
    </div>
  );
}
